import axios from "axios";
import { useState } from "react";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import { Container, Form, Button, Alert } from "react-bootstrap";
import { HelpLinks, SESSION_TTL } from "../Utils";
import LoadGeneralData from "../LoadGeneralData";

function SignIn(props) {
  const API_URL = process.env.REACT_APP_BACKEND_URL + "/api";
  const ls = require("localstorage-ttl");

  const [email, setEmail] = useState();
  const [password, setPassword] = useState();

  const [errorMessage, setErrorMessage] = useState("");
  const history = useHistory();
  const { setActiveUser, setLoggedIn } = props;
  const [isLoading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    axios
      .post(API_URL + "/auth/local", {
        identifier: email,
        password: password,
      })
      .then((res) => {
        let user = res.data.user;
        const jwt = res.data.jwt;

        axios
          .get(`${API_URL}/users/me?populate=*`, {
            headers: {
              Authorization: `Bearer ${jwt}`,
            },
          })
          .then((res) => {
            var moment = require("moment");

            user.role = res.data.role.type;

            let level = 0;
            if (user.role === "instructor") level = 1;
            else if (user.role === "examinador") level = 2;
            else if (user.role === "administrador") level = 3;
            user.level = level;

            let isDanNoAikikai = false;

            const exams = res.data.exams
              .filter((exam) => exam.state === "APPROVED")
              .map((exam) => {
                if (
                  exam.grade.color === "black" &&
                  (!exam.dateAikikai || !exam.idAikikai) &&
                  moment(exam.date).add(3, "months") < moment()
                ) {
                  // si hace mas de X meses que rindió DAN
                  // y no tiene los datos aikikai cargados
                  isDanNoAikikai = true;
                }
                return exam;
              })
              .filter(
                (exam) =>
                  exam.grade.color !== "black" ||
                  (exam.grade.color === "black" &&
                    exam.dateAikikai &&
                    exam.idAikikai)
              )
              .map((exam) => {
                if (exam.dateAikikai) {
                  exam.id = exam.idAikikai;
                  exam.date = exam.dateAikikai;
                }
                return exam;
              });

            user.isDanNoAikikai = isDanNoAikikai;

            exams.sort(function (a, b) {
              return moment(b.date).toDate() - moment(a.date).toDate();
            });

            ls.set("jwt", JSON.stringify(jwt), SESSION_TTL);
            ls.set("userData", JSON.stringify(user), SESSION_TTL);
            ls.set("userExams", JSON.stringify(exams), SESSION_TTL);

            LoadGeneralData();

            setActiveUser(user);
            setLoggedIn(true);
            history.push("/");
          })
          .catch((error) => {
            setLoading(false);
            console.log("Error with user exams:", error.response);
          });
      })
      .catch((error) => {
        setLoading(false);
        console.log("Error with login:", error.response.data.error);
        if (error.response.status === 400) {
          setErrorMessage("Datos incorrectos!");
        } else {
          setErrorMessage(
            "No pudimos identificarlo, pruebe nuevamente en unos minutos."
          );
        }
      });
  };

  return (
    <Container
      id="main-container"
      className="p-3 mb-4 d-grid h-100 bg-light rounded-3"
    >
      <Form
        id="sign-in-form"
        className="text-center w-100"
        onSubmit={(e) => handleSubmit(e)}
      >
        <Form.Group className="mb-3" controlId="formUser">
          <Form.Label>Número Documento</Form.Label>
          <Form.Control
            size="lg"
            type="text"
            placeholder="Usuario"
            onChange={(e) => setEmail(e.target.value)}
          />
        </Form.Group>
        <Form.Group className="mb-3" controlId="formPassword">
          <Form.Label>Contraseña</Form.Label>
          <Form.Control
            size="lg"
            type="password"
            placeholder="Password"
            onChange={(e) => setPassword(e.target.value)}
          />
        </Form.Group>
        <Button variant="primary" type="submit" disabled={isLoading}>
          {isLoading ? "Procesando…" : "INGRESAR"}
        </Button>
        {errorMessage ? (
          <Alert className="mt-3" variant="danger">
            {errorMessage}
          </Alert>
        ) : (
          <></>
        )}
        <Link
          to="/forgot-password"
          style={{ display: "block", marginTop: "10px" }}
        >
          {" "}
          Olvidé la contraseña{" "}
        </Link>
        <HelpLinks />
      </Form>
    </Container>
  );
}
export default SignIn;
